/**
 * Two side-by-side countdown cards: next event + wedding day.
 * Self-hides if neither value is present.
 */
import React from 'react';
import { Card } from '../ui/card';

function fmtLongDate(dateStr) {
  if (!dateStr) return null;
  return new Date(dateStr).toLocaleDateString('en-US', {
    weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
  });
}

function CountdownCard({ label, event, accent }) {
  if (!event) return null;
  const colorClass = accent === 'moss' ? 'border-l-moss text-moss' : 'border-l-terracotta text-terracotta';
  return (
    <Card className={`card-surface p-6 border-l-4 ${colorClass.split(' ')[0]}`}>
      <p className="text-xs text-muted uppercase tracking-wider mb-1">{label}</p>
      <p className="font-serif text-xl text-charcoal">{event.name}</p>
      <div className="flex items-baseline gap-2 mt-2">
        <span className={`font-mono text-4xl tracking-tight ${colorClass.split(' ')[1]}`}>
          {event.days_until}
        </span>
        <span className="text-sm text-muted">days away</span>
      </div>
      {event.date && <p className="text-xs text-muted mt-1">{fmtLongDate(event.date)}</p>}
    </Card>
  );
}

export default function CountdownCards({ countdown }) {
  const { nearest_event, wedding_date } = countdown || {};
  if (!nearest_event && !(wedding_date && wedding_date.days_until >= 0)) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="countdown-card">
      <CountdownCard label="Next Event" event={nearest_event} accent="terracotta" />
      {wedding_date && wedding_date.days_until >= 0 && (
        <CountdownCard label="Wedding Day" event={wedding_date} accent="moss" />
      )}
    </div>
  );
}
